module.exports = __webpack_public_path__ + "static/media/Farm.6e4821dd.png";